import { Component, OnInit } from '@angular/core';
import { ServiceMangeService } from 'src/app/services/service-mange.service';
import { Router } from '@angular/router';
import { local } from 'd3-selection';

@Component({
  selector: 'app-main-ser-req',
  templateUrl: './main-ser-req.component.html',
  styleUrls: ['./main-ser-req.component.css'],
  
})
export class MainSerReqComponent implements OnInit {

  constructor(private rest : ServiceMangeService , private route : Router){}

  active_arr :any = []
  pending_arr:any = []
  closed_arr :any = []
  complet_arr :any = []
  ngOnInit(){
    this.getDataActive()
    this.getDataPending()
    this.getDataClosed()
    this.getDataComplet()
  }

  getDataActive(){
    this.rest.serviceReuest('Active').subscribe((res:any) => {
      console.log(res)
      this.active_arr = res
    })
  }
  getDataPending(){
    this.rest.serviceReuest('Pending').subscribe((res:any) => {
      console.log(res)
      this.pending_arr = res
    })
  }
  getDataClosed(){
    this.rest.serviceReuest('Closed').subscribe((res:any) => {
      console.log(res)
      this.closed_arr = res
    })
  }
  getDataComplet(){
    this.rest.serviceReuest('Complete').subscribe((res:any) => {
      console.log(res)
      this.complet_arr = res
    })
  }

  request_details(item:any){
    localStorage.setItem("servItem",JSON.stringify(item))
    this.route.navigate(['pages/service_request_Details']);
  }

}
